export default [
  {
    path: 'notices/certificadoscaducar',
    name: 'notices/certificadoscaducar',
    component: () => import('@/views/certificates/Certificates.vue'),
    meta: { registerNavFromMenu: true, status: 99999, notice: 'certificadoscaducar' }
  },
  {
    path: 'notices/certificadoscaducados',
    name: 'notices/certificadoscaducados',
    component: () => import('@/views/certificates/Certificates.vue'),
    meta: { registerNavFromMenu: true, status: 99999, notice: 'certificadoscaducados' }
  },
  {
    path: 'notices/uploaderrors',
    name: 'notices/uploaderrors',
    component: () => import('@/views/notices/UploadInvoice.vue'),
    meta: { registerNavFromMenu: true }
  }
]
